import { Image as ImageView } from 'react-native';

const Image = ({ resizeMode, size, style, ...props }) => {
  return <ImageView resizeMode={resizeMode} style={style} {...props} />;
};

export default Image;
